import React, { createContext, useCallback, useContext, useEffect, useReducer, } from "react";
import { leaderboardActions } from "./actions";
import Spinner from "@/frontend/components/Common/Spinner";
import { leaderboardInitialState, leaderboardReducer } from "./reducer";
export const LeaderboardContext = createContext({});
export const useLeaderboard = () => useContext(LeaderboardContext);
export const LeaderboardProvider = ({ children }) => {
    const [state, dispatch] = useReducer(leaderboardReducer, leaderboardInitialState);
    const renderContent = () => {
        if (state.pageStatus === "loading") {
            return React.createElement(Spinner, null);
        }
        if (state.pageStatus === "error") {
            return React.createElement("h2", { className: "text-center" }, "an error occurred");
        }
        if (state.pageStatus === "success") {
            return children;
        }
        return null;
    };
    const getContextValue = useCallback(() => ({ state, dispatch }), [state, dispatch]);
    useEffect(() => {
        leaderboardActions.getLeaderboard(state.filter, dispatch);
    }, []);
    return (React.createElement(LeaderboardContext.Provider, { value: getContextValue() }, renderContent()));
};
